import { AwsRum } from 'aws-rum-web';
import constants from '@/constants';
const { Common } = constants;

const { APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, CONFIG } =
  Common.CLOUDWATCH_RUM_CONFIG.getConfig();

export const awsRumHandler = {
  awsRumInstance: null,
  initialize() {
    this.awsRumInstance = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      CONFIG
    );
  },
  getInstance() {
    return this.awsRumInstance;
  },
  /**
   * @param {
   *   pageName: 'gatewayPage',
   *   buttonName: 'search', // only Button statistics
   *   widgetName: 'bestSeller', // only Widget statistics
   * } configParam
   */
  recordClickEvent(configParam) {
    this.getInstance().recordEvent('clickEvent', {
      ...configParam,
      visitCount: 1
    });
  },
  /**
   * @param {
   *  pageName: 'gatewayPage',
   *  eventName: 'ATF'
   *  duration: 100
   * } configParam
   */
  recordLoadingEvent(configParam) {
    this.getInstance().recordEvent('loadingEvent', {
      ...configParam,
      visitCount: 1
    });
  },
  /**
   * @param {
   *  pageName: 'cartPage',
   *  eventName: 'clearCart'
   * } configParam
   */
  recordBusinessEvent(configParam) {
    this.getInstance().recordEvent('businessEvent', {
      ...configParam,
      visitCount: 1
    });
  },
  recordResponseDuration(axiosRes) {
    const duration =
      new Date().getTime() - axiosRes.config.meta.requestStartedTime;
    const fullPath = axiosRes.config.url;
    const apiUrl = fullPath.split('?')[0];
    setTimeout(() => {
      this.awsRumInstance.recordEvent('apiDurationEvent', {
        apiUrl,
        fullPath,
        visitCount: 1,
        duration
      });
    }, 3000);
  }
};
